import styled from "styled-components"

export const SearchWrapper = styled.div`
    width: 600px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    position: relative;
    &:focus-within{
        .suggestion{
            display: block;
        }
    }
    .search_input{
        width: 100%;
        padding: 0 12px;
        color:#1c1c1c;
    }
    .loading_search{
        animation: spinner 0.8s linear infinite;
    }
    .btn_clear_input{
        margin-right: 8px;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover{
            background-color: whitesmoke;
        }
    }
    .btn_search{
        min-width: 40px;
        height: 100%;
        background-color: red;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        &:hover{
            opacity: 0.6;
        }
        i{
            color: #ffffff;
            font-size: 1.2rem;
        }
    }
    .suggestion{
        position: absolute;
        top: 45px;
        background-color: #ffffff;
        width: 100%;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);
        animation: fadeOpacity linear 0.5s;
        z-index: 18;
        display: none;
        .title{
            font-size: 1.0rem;
            color: #796d6d;
        padding: 12px;

            border-bottom: 1px solid #e2c1c1;
            padding-bottom: 4px;
        }
    }
    .search_list{
        padding: 0;
        margin: 0;
        list-style: none;
        .search_item{
            &:hover{
                background-color: #ececec;
            }
        }
        .search_link{
            padding: 12px 0;
            display: flex;
            width: 100%;
            height: 100%;
            .thumbnail{
                max-width: 120px;
                min-width: 120px;
                min-height: 70px;
                max-height: 70px;
                display: flex;
                align-items: center;
                justify-items: center;
                img{
                    width: 100%;
                    max-height: 70px;
                    object-fit: contain;
                }
            }
            .info{
                .name{
                    font-size: 1.0rem;
                    color: #333;
                    font-weight: 700;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
                .price{
                    color: #fd475a;
                    font-weight: 700;
                    font-style: 1.4rem;
                }
            }
        }
    }
    @keyframes fadeOpacity {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

`
